// パスワードリセット 新パスワード入力画面
import React, { useState } from 'react';
import './List.css';
import '../App.css';
import { Button, Snackbar, TextField } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor } from '../GlobalState';
import { useHistory } from 'react-router-dom';
import { resetPasswordWithToken } from '../apicalls/resetPassword';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import logo from '../assets/logo1.png';

export const ResetPasswordPage: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      },
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF'
      },
      input: {
        borderColor: '#c1c1c1',
        borderWidth: 1,
        width: 400,
        marginTop: 25
      },
      table1: {}
    })
  );

  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const history: any = useHistory();
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const classes = useStyles();

  const resetYourPassword = () => {
    if (password1.trim() === '' || password2.trim() === '') {
      setOpen(true);
      setErrorMessage('すべてのフィールドは必須です。');
    } else if (password1.trim() !== password2.trim()) {
      setOpen(true);
      setErrorMessage('パスワードが一致しません。');
    } else {
      resetPasswordWithToken(
        history.location.pathname.split('/reset/password/')[1],
        password1.trim(),
        password2.trim()
      ).then(data => {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.replace('/');
            }, 2000);
          }
        }
      });
    }
  };

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <div
        className={classes.container}
        style={{
          backgroundColor: buttonColor,
          padding: 15,
          minHeight: window.innerHeight - 30
        }}
      >
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openSuccess}
          autoHideDuration={4000}
          onClose={handleCloseSuccess}
        >
          <Alert onClose={handleCloseSuccess} severity='success'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <div
          style={{
            width: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
          className='container'
        >
          <div>
            <img
              style={{ width: 100, height: 60, objectFit: 'contain' }}
              alt='logo'
              src={logo}
            />
          </div>
          <div>
            <TextField
              className={classes.input}
              label='パスワード'
              type='password'
              autoComplete='current-password'
              variant='outlined'
              onChange={text => {
                setPassword1(text.target.value);
              }}
            />
          </div>

          <div>
            <TextField
              className={classes.input}
              label='パスワード再入力'
              type='password'
              autoComplete='current-password'
              variant='outlined'
              onChange={text => {
                setPassword2(text.target.value);
              }}
            />
          </div>

          <Button
            onClick={() => {
              resetYourPassword();
            }}
            style={{ backgroundColor: mainColor, marginTop: 20, width: 400 }}
            variant='contained'
            color='primary'
          >
            リセット
          </Button>
        </div>
      </div>
    </div>
  );
};
